import React, { useEffect, useState } from "react";
import "./App.scss";
import Login from "./pages/auth/Login/Login";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Register from "./pages/auth/Register/Register";
import Layout from "./pages/Layout";
import Home from "./pages/Dashboard/Home";
import { AdminRuotes, LogBookRuotes, TrainingRuotes } from "./routes";
import { useAppSelector } from "./hooks/app";
import { getActiveTab, getAllTabs } from "./store/slices/layout-slice";
import { IRouteObject } from "./types/routes.types";
import { MAIN_TABS } from "./constants";
import Report from "./pages/Dashboard/Reports/Report";
import { getUser } from "./store/slices/auth-slice";
import Profile from "./pages/Dashboard/Profile/Profile";

import "bootstrap/dist/css/bootstrap.min.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import VerifyAccount from "./pages/auth/Verify/VerifyAccount";
import ForgetPassword from "./pages/auth/ForgetPassword/ForgetPassword";
import ChangePassword from "./pages/auth/ChangePassword/ChangePassword";
import Forbidden from "./pages/Forbidden";

function App() {
  const tabs = useAppSelector(getAllTabs);
  const activeTab = useAppSelector(getActiveTab);
  const [activeRoutes, setActiveRoutes] = useState<IRouteObject[]>();
  const user = useAppSelector(getUser)
  useEffect(() => {
    if (activeTab) {
      switch (activeTab.value) {
        case MAIN_TABS.LOG_BOOK: {
          setActiveRoutes(LogBookRuotes);
          break;
        }
        case MAIN_TABS.TRAINING: {
          setActiveRoutes(TrainingRuotes);
          break;
        }
        case MAIN_TABS.ADMIN: {
          setActiveRoutes(AdminRuotes);
          break;
        }
        default: {
          setActiveRoutes(LogBookRuotes);
          break;
        }
      }
    }
  }, [activeTab, tabs]);

  return (
    <div>
      <Router>
        {user && <Layout />}
        <Routes>
          <Route path="/register" element={!user ? <Register /> : <Navigate to="/" />} />
          <Route
            path="/login"
            element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/reports" element={<Report />}> </Route>
          <Route path="/profile" element={<Profile />}> </Route>
          <Route path="/forbidden" element={<Forbidden/>}> </Route>
          <Route path="/verify-account/:token" element={<VerifyAccount />}> </Route>
          <Route path="/change-password/:token" element={<ChangePassword />}> </Route>
          <Route path="/forget-password" element={<ForgetPassword />}> </Route>
          <Route path="/" element={<Home />} />

          {TrainingRuotes?.map((route, i) => {
            return (
              <Route key={i} path={route.path} element={route.element}></Route>
            );
          })}
          {LogBookRuotes?.map((route, i) => {
            return (
              <Route key={i} path={route.path} element={route.element}></Route>
            );
          })}
            {AdminRuotes?.map((route, i) => {
            return (
              <Route key={i} path={route.path} element={route.element}></Route>
            );
          })}
        </Routes>
      </Router>

    </div>
  );
}

export default App;
